import React from 'react'
import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderTitle from '../../components/header/HeaderTitle'
import HeaderContentSmall from '../../components/header/HeaderContentSmall'
import SubHeading from '../../components/inner/venderProduct/SubHeading'
import FullImage from '../../components/inner/venderProduct/FullImage'
import ImageTextPanel from '../../components/inner/technologies/ImageTextPanel'

import MobileImage01 from '../../assets/technologies/mobileImage01.png'
import AutomotiveImage02 from '../../assets/technologies/automotiveImage02.png'
import MobileImage02 from '../../assets/technologies/mobileImage02.png'
import MobileImage03 from '../../assets/technologies/mobileImage03.png'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';



const Mobile = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.technologies?.mobile || siteCopy.en.pages.technologies.mobile;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>

        <div style={{height: '60px'}}></div>

        <HeaderContentSmall>
          {renderLines(copy.introParagraphs)}
        </HeaderContentSmall>

        <HeaderContentSmall>
          {renderLines([copy.secondParagraph])}
        </HeaderContentSmall>

        <SubHeading>{copy.solutionTitle}</SubHeading>

        <FullImage Item={MobileImage01} />

        {copy.solutions.map((solution, index) => (
          <ImageTextPanel 
            key={index}
            Image={index === 0 ? AutomotiveImage02 : index === 1 ? MobileImage02 : MobileImage03}
            Title={solution.title}
            Link={solution.link}
            Text={<>{renderLines(solution.text)}</>}
          />
        ))}

      </HeaderContainer>

    </>
  )
}

export default Mobile
